(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.numberSpinners = {
    attach: function (context, settings) {
      const $spinners = $('.js-number-spinner', context).once().find(':input[type="number"]');
      $spinners.spinner();
    }
  };
})(window.Drupal, window.jQuery);
